import React from 'react';
import ChartSettingsComponent from '../components/chartsettings.component';

export default function ChartSettingsContainer(props) {
  return <ChartSettingsComponent {...props} />;
}
